import { FC, useEffect } from 'react';
import { STORAGE_KEYS } from '@/constants/storageKeys';
import {
  calculateBannersHeight,
  clearSavedData,
  getLastScrollPosition,
  getPreviousBannersHeight,
} from '@/components/ScrollSaver/ScrollSaver.helpers';
import {
  DELAY_TO_HIDE_HEADER,
  DELAY_TO_RESTORE_POSITION,
} from '@/components/ScrollSaver/ScrollSaver.constants';
import { PAGE_WITH_ADS } from '@/constants/common';

interface Props {
  page: PAGE_WITH_ADS;
}

export const ScrollSaver: FC<Props> = ({ page }) => {
  function scrollToTarget(finalScrollPosition: number) {
    window.scrollTo(0, finalScrollPosition);

    setTimeout(() => {
      window.scrollTo(0, finalScrollPosition + 1);
    }, DELAY_TO_HIDE_HEADER);
  }

  useEffect(() => {
    if (
      localStorage.getItem(STORAGE_KEYS.NEED_TO_RESTORE_SCROLL_POSITION) ===
      'false'
    ) {
      localStorage.removeItem(STORAGE_KEYS.NEED_TO_RESTORE_SCROLL_POSITION);
      clearSavedData();
      return;
    }

    setTimeout(() => {
      const previousBannersHeight = getPreviousBannersHeight(page);

      const newBannersHeight = calculateBannersHeight();

      const lastScrollPosition = getLastScrollPosition(page);

      const finalScrollPosition =
        lastScrollPosition - previousBannersHeight + newBannersHeight;

      const isNeedToScrollTo = newBannersHeight !== finalScrollPosition;

      if (isNeedToScrollTo) {
        scrollToTarget(finalScrollPosition);
      }
      clearSavedData();
    }, DELAY_TO_RESTORE_POSITION);
  }, []);

  return null;
};
